import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const AiTrafficPage = lazyWithRetry(() => import('./pages/AiTrafficPage'))
const DeliverablesPage = lazyWithRetry(() => import('./pages/DeliverablesPage'))
const PerformanceHomePage = lazyWithRetry(() => import('./pages/PerformanceHomePage'))

const routes: AppRoute[] = [
  {
    path: 'overview',
    children: [
      {
        path: 'ai-traffic',
        element: AiTrafficPage,
        meta: {
          title: 'performanceHome.aiTrafficPage.title',
          require: { minRole: ROLE.MEMBER },
        },
      },
      {
        path: 'deliverables',
        element: DeliverablesPage,
        meta: {
          title: 'performanceHome.deliverablesPage.title',
          require: { minRole: ROLE.MEMBER },
        },
      },
    ],
  },
  {
    path: 'seo',
    children: [
      {
        path: 'details',
        element: PerformanceHomePage,
        meta: {
          title: 'sidebarNav.seoDetails',
          require: { minRole: ROLE.MEMBER },
        },
      },
    ],
  },
]

export default routes
